import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function FaqQuestion(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "FaqQuestion", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.0554 4.43286H7.16916c-1.62947 0-2.95041 1.32094-2.95041 2.95031V18.0616c0 1.6294 1.32094 2.9504 2.95041 2.9504v2.3145c0 .6478.74803 1.0092 1.25559.6065l3.68095-2.921h11.9498c1.6295 0 2.9503-1.321 2.9503-2.9504V7.38317c-.0001-1.62937-1.3209-2.95031-2.9504-2.95031Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M23.9446 23.8977h16.8863c1.6294 0 2.9504 1.3209 2.9504 2.9504v10.6784c0 1.6295-1.321 2.9504-2.9504 2.9504v2.3145c0 .6478-.7481 1.0093-1.2556.6066l-3.6809-2.921H23.9446c-1.6295 0-2.9504-1.3209-2.9504-2.9504V26.8481c0-1.6295 1.3209-2.9504 2.9504-2.9504Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.8542 9.41392c.466-.40069 1.4817-.97837 2.7954-.97837 1.6678 0 2.8884 1.00622 2.8884 2.42255 0 1.4164-1.4442 2.0966-1.7238 2.2177l-.028.4844c-.0002.0988-.0396.1934-.1094.2633-.0698.0699-.1645.1093-.2632.1095h-1.3418c-.0988-.0002-.1935-.0396-.2633-.1095-.0699-.0698-.1093-.1645-.1095-.2633l-.0651-1.1647c0-.1117.0931-.1678.2235-.205.6243-.177 1.1648-.5496 1.1648-.9597 0-.3261-.2423-.5589-.6522-.5589-.438 0-.9505.2701-1.2766.5216-.0651.0467-.1397.0839-.2142.0839-.1211 0-.2237-.0653-.2982-.1677l-.8199-1.18343c-.0467-.06525-.0746-.15835-.0746-.23288.0001-.12112.0746-.19556.1677-.27947Zm1.7704 5.96248c0-.1491.1306-.2795.2795-.2795h1.6773c.149 0 .2795.1304.2795.2795v1.3045c0 .1491-.1306.2795-.2795.2795h-1.6773c-.149 0-.2795-.1304-.2795-.2795v-1.3045Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.6294 28.9114c.466-.4006 1.4817-.9784 2.7954-.9784 1.6679 0 2.8884 1.0063 2.8884 2.4226 0 1.4164-1.4441 2.0965-1.7237 2.2177l-.028.4844c-.0003.0988-.0396.1934-.1095.2633-.0698.0699-.1645.1092-.2632.1095H31.847c-.0988-.0003-.1934-.0397-.2633-.1095-.0698-.0699-.1092-.1645-.1095-.2633l-.0651-1.1647c0-.1117.0931-.1677.2235-.2051.6244-.177 1.1649-.5496 1.1649-.9596 0-.3262-.2424-.559-.6523-.559-.4379 0-.9505.2701-1.2765.5216-.0652.0467-.1397.084-.2143.084-.1211 0-.2237-.0653-.2982-.1676l-.8199-1.1834c-.0466-.0653-.0746-.1584-.0746-.2329.0001-.1212.0747-.1958.1677-.2796Zm1.7704 5.9625c0-.1491.1306-.2795.2796-.2795h1.6773c.1489 0 .2794.1305.2794.2795v1.3044c0 .1492-.1306.2795-.2794.2795h-1.6773c-.1491 0-.2796-.1304-.2796-.2795v-1.3044Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
FaqQuestion.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "FaqQuestion"
};
validateTidalLicense();
export {
  FaqQuestion
};
//# sourceMappingURL=FaqQuestion.js.map
